import { Typography } from '@e3dc-react/shell/Elements/Typography'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Box } from '@mui/material'
import BatteryStatusItemValues from './BatteryStatusItemValues'

const useStyles = makeStyles()(theme => ({
  textContainer: {
    display: 'inline-block',
    textAlign: 'justify',

    ':first-child': {
      marginTop: 0,
    },

    br: {
      display: 'none',
    },
  },
}))

interface Props {
  title: string
  text: string
  isLowVoltageBattery: boolean
  moduleCount: number
  values?: { [key: string]: Array<string | number> }
  valueKeys?: { [key: string]: { highVoltage: string; lowVoltage: string } }
}

/**
 * Single item for the battery status section
 */
const BatteryStatusItem: React.FC<Props> = ({ title, text, isLowVoltageBattery, moduleCount, values, valueKeys }) => {
  const { classes } = useStyles()

  return (
    <Box className={classes.textContainer}>
      <Typography variant="subtitle2" sx={{ mt: 1, mb: 1 }}>
        {title}
      </Typography>
      <Typography variant="subtitle2" component={'span'}>
        {text}
      </Typography>
      {values && valueKeys && (
        <BatteryStatusItemValues values={values} valueKeys={valueKeys} moduleCount={moduleCount} isLowVoltageBattery={isLowVoltageBattery} />
      )}
    </Box>
  )
}

export default BatteryStatusItem
